import { createContext, useContext, useState, ReactNode } from "react";

interface FormDirtyContextType {
  isDirty: boolean;
  setIsDirty: (dirty: boolean) => void;
  resetDirty: () => void;
}

const FormDirtyContext = createContext<FormDirtyContextType | undefined>(
  undefined,
);

interface FormDirtyProviderProps {
  children: ReactNode;
}

export function FormDirtyProvider({ children }: FormDirtyProviderProps) {
  const [isDirty, setIsDirty] = useState(false);

  const resetDirty = () => {
    setIsDirty(false);
  };

  return (
    <FormDirtyContext.Provider value={{ isDirty, setIsDirty, resetDirty }}>
      {children}
    </FormDirtyContext.Provider>
  );
}

export function useFormDirtyContext() {
  const context = useContext(FormDirtyContext);
  if (context === undefined) {
    throw new Error(
      "useFormDirtyContext must be used within a FormDirtyProvider",
    );
  }
  return context;
}
